module.exports = __webpack_public_path__ + "img/icon-secure-payment.67642b87.svg";